module.exports = __webpack_public_path__ + "media/Safe.bace0202.mp4";